module.exports = __webpack_public_path__ + "static/media/featurewall.06c1deb8.png";